import * as React from 'react';

import { useStyles } from './styles';

function BaseValueTag() {
  const classes = useStyles();

  return <span className={classes.container}>Valor base</span>;
}

export { BaseValueTag };
